module.exports = __webpack_public_path__ + "assets/img/9697e3b8ccbebee98377e7069cdc7dc8.svg";